import { createAction, props } from '@ngrx/store';
import { IFormErrorNotification, INotification } from '../models/notification.model';

export const setNotification = createAction(
  '[Notification] set Notification',
  props<{ data: INotification }>(),
);

export const clearNotification = createAction(
  '[Notification] Clear Notification',
);

export const clearDeploymentNotification = createAction(
  '[Notification] Clear Deployment Notification',
);

export const setPageNotification = createAction(
  '[Notification-Page] set Page Notification',
  props<{ data: INotification }>(),
);

export const clearPageNotification = createAction(
  '[Notification-Page] Clear Page Notification',
);

export const setFormErrorNotification = createAction(
  '[Notification-Page] set Form Error Notification',
  props<{ data: IFormErrorNotification }>(),
);

export const clearFormErrorNotification = createAction(
  '[Notification-Page] Clear Form Error Notification',
);

export const setDeploymentNotification = createAction(
  '[Notification] set Deployment Notification',
  props<{ data: INotification }>(),
);
